import React from "react";
import { CustomerData } from "../../types";

interface Props {
  customer: CustomerData;
}

const CustomerCard: React.FC<Props> = ({ customer }) => {
  const c = customer.ledger[0];

  return (
    <div className="ledger-customer-card">
      <h2 className="ledger-card-title">Customer details</h2>
      <ul className="space-y-2" id="ledger-customer-list">
        <li className="flex"><strong className="w-[150px]">Name</strong>: {c.customer_name}</li>
        <li className="flex"><strong className="w-[150px]">Client ID</strong>: {c.customer_ref_id || "N/A"}</li>
        <li className="flex"><strong className="w-[150px]">Phone</strong>: {c.customer_phone_number}</li>
        <li className="flex"><strong className="w-[150px]">Email</strong>: {c.Email || "N/A"}</li>
      </ul>
    </div>
  );
};

export default CustomerCard;
